import { gql } from '@apollo/client'

const COURSE_TYPE_QUERY = gql`
  query courseType($id: ID!) {
    courseType(id: $id) {
      id
      name
      description
      position
      maxPosition
      updatedAt
      updatedBy {
        id
        name
      }
      node {
        id
        name
        isCurationEnabled
        level
        idPath
        namePath
      }
      isDefaultFilter
      isIgnored
      synonyms
      isExcludedFromSearch
      imageUrl
      rearrangementScore
    }
  }
`

export default COURSE_TYPE_QUERY
